import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useImg, useText } from 'hooks';
import { MOBILE, TABLET, TO_DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';
import FormBlock from '../Form/FormBlock';

const Top = ({ formRef }) => {
  return (
    <ChangeableBackgroundSection
      id="top-wrapper-bg"
      defaultStyle={{ background: '#fff' }}
      wrapperCss={wraperStyles}
    >
      <TopContainer>
        <Wrapper>
          <TopTitle>{useText('top__title', true)}</TopTitle>
          <TopSubtitle>{useText('top__subtitle', true)}</TopSubtitle>
          <TopTimestamp>
            {useImg('time.svg', 'time')}
            {useText('top__day_text', true)}
          </TopTimestamp>
          <Image>
            {useImg('top_img.webp', 'top_img')}
            {useText('top__img_text', true)}
          </Image>
          <TopText>{useText('top__text', true)}</TopText>
          <TopForm ref={formRef}>
            <FormBlock />
          </TopForm>
        </Wrapper>
      </TopContainer>
    </ChangeableBackgroundSection>
  );
};

const wraperStyles = css`
  padding: 30px 0 0;
`;

const TopContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  @media ${TABLET} {
    max-width: 1200px;
  }

  @media ${MOBILE} {
    flex-direction: column;
    max-width: 768px;
    padding: 0;
  }
`;

const Wrapper = styled.div`
  max-width: 800px;

  @media ${TABLET} {
    padding-right: 10px;
    padding-left: 20px;
    max-width: 700px;
  }

  @media ${MOBILE} {
    padding: 0 20px;
  }
`;

const TopTitle = styled.div`
  h1 {
    font-family: 'ReithSerif';
    margin: 0;
    color: #000;
    font-weight: 500;
    font-size: 44px;
    line-height: 48px;

    span {
      background: #eb0000;
      color: #fff;
      padding: 0 5px;
      font-size: 22px;
      position: relative;
      top: 12px;
    }
  }

  @media ${MOBILE} {
    h1 {
      font-size: 32px;
      line-height: 36px;

      span {
        top: 8px;
      }
    }
  }
`;

const TopSubtitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #000;
  margin-block: 16px;
  max-width: 580px;
`;

const TopTimestamp = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  color: #545658;
  display: flex;
  gap: 6px;
  padding-bottom: 16px;
`;

const Image = styled.div`
  position: relative;
  margin-top: 24px;
  cursor: pointer;

  span {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    position: absolute;
    bottom: 4px;
    left: 0;
    background: #141414;
    color: #f6f6f6;
    padding: 4px;
    text-transform: uppercase;
  }
`;

const TopText = styled.div`
  color: #545658;
  border-left: 1px solid #8a8c8e;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  padding-left: 8px;
  margin-top: 8px;
`;

const TopForm = styled.div`
  min-width: 448px;
  width: 100%;
  padding: 20px 0;
  background-color: #fff;

  @media ${MOBILE} {
    max-width: none;
    min-width: auto;
  }

  @media ${TO_DESKTOP} {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

Top.propTypes = {
  formRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.shape({ root: PropTypes.string.isRequired }),
    }),
  ]).isRequired,
};

export default Top;
